// polyfills
import '@babel/polyfill'
import 'mutationobserver-shim'
import 'whatwg-fetch'

import Vue from 'vue'
import './plugins'
import './assets/scss/styles.scss'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './registerServiceWorker'
import './components/globals'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
